jQuery(document).on('ready', function () {
    const scrollDuration = 1000;
    let offset = 0;
    let subchapterString = 'subchapter-';
    let hash = window.location.hash;
    let subchapterTarget = '';
    if (hash.includes(subchapterString)) {
        let hashSubchapterNumber = parseInt(hash.slice(hash.length - 1));
        let hashSubchapterBase = hash.slice(0, -1);
        if (Number.isNaN(hashSubchapterNumber) == false) {
            if (hashSubchapterNumber > 1) {
                subchapterTarget = jQuery('.wm-openSubchapterButton > a[href=' + hash + ']').attr('href');
                let tempSubchapterTarget = '';
                let tempHash = '';
                let subchapterCounter = hashSubchapterNumber;
                while (subchapterCounter > 0) {
                    tempHash = hashSubchapterBase + subchapterCounter.toString();
                    tempSubchapterTarget = jQuery('.wm-openSubchapterButton > a[href=' + tempHash + ']').attr('href');
                    jQuery(tempSubchapterTarget).removeClass('-subchapterHidden');
                    subchapterCounter = subchapterCounter - 1;
                }
            }
            else {
                subchapterTarget = jQuery('.wm-openSubchapterButton > a[href=' + hash + ']').attr('href');
                jQuery(subchapterTarget).removeClass('-subchapterHidden');
            }
            let windowSize = jQuery(window).width();
            if (windowSize < 1025) {
                offset = 50;
            }
            jQuery([document.documentElement, document.body]).animate({
                scrollTop: jQuery(subchapterTarget).offset().top
            }, scrollDuration);
        }
    }
});
jQuery(window).on('hashchange', function () {
    const scrollDuration = 1000;
    let offset = 0;
    let subchapterString = 'subchapter-';
    let hash = window.location.hash;
    let subchapterTarget = '';
    if (hash.includes(subchapterString)) {
        let hashSubchapterNumber = parseInt(hash.slice(hash.length - 1));
        let hashSubchapterBase = hash.slice(0, -1);
        if (Number.isNaN(hashSubchapterNumber) == false) {
            if (hashSubchapterNumber > 1) {
                subchapterTarget = jQuery('.wm-openSubchapterButton > a[href=' + hash + ']').attr('href');
                let tempSubchapterTarget = '';
                let tempHash = '';
                let subchapterCounter = hashSubchapterNumber;
                while (subchapterCounter > 0) {
                    tempHash = hashSubchapterBase + subchapterCounter.toString();
                    tempSubchapterTarget = jQuery('.wm-openSubchapterButton > a[href=' + tempHash + ']').attr('href');
                    jQuery(tempSubchapterTarget).removeClass('-subchapterHidden');
                    subchapterCounter = subchapterCounter - 1;
                }
            }
            else {
                subchapterTarget = jQuery('.wm-openSubchapterButton > a[href=' + hash + ']').attr('href');
                jQuery(subchapterTarget).removeClass('-subchapterHidden');
            }
            let windowSize = jQuery(window).width();
            if (windowSize < 1025) {
                offset = 50;
            }
            jQuery([document.documentElement, document.body]).animate({
                scrollTop: jQuery(subchapterTarget).offset().top
            }, scrollDuration);
        }
    }
});
